// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search__top__headline[data-v-da73d5cc]{text-align:center;width:-moz-fit-content;width:fit-content}.search__location__title[data-v-da73d5cc],.search__results__title[data-v-da73d5cc],.search__top__title[data-v-da73d5cc]{margin-left:68px}.search__channel-logo-picture[data-v-da73d5cc]{border-radius:100%;display:block;height:80px;width:80px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
